import _ from 'lodash';
import { CommunicationLogEntry } from '../model/communication-log-entry.model';

export function hasDisplayProperties( entry: CommunicationLogEntry ): boolean {
    if ( !entry.additionalAttributes ) {
        return false;
    }

    const displayProperties = entry.additionalAttributes?.displayProperties;

    return typeof displayProperties === 'object' && displayProperties !== null;
}